// MUST be the very first import in index.tsx — before any module that contains
// a dynamic import(). Create React App hardcodes webpack's publicPath to "/",
// but this app's JS is served from the plugin's build/ directory
// (…/wp-content/plugins/sjd-booking/app/build/). Point webpack's runtime chunk
// loader there so lazily-loaded step chunks resolve to the plugin build path
// instead of 404ing against the site root (which would break the step and, for
// step 6, the payment flow).
//
// The value is injected by WordPress (app/app.php) as window.SJD_BUILD_URL in an
// inline script printed immediately BEFORE the main bundle. If it is absent
// (e.g. serving `build/` from the site root in a local static harness) we leave
// webpack's default "/" untouched.
declare let __webpack_public_path__: string;

const buildUrl = (window as unknown as { SJD_BUILD_URL?: string })
  .SJD_BUILD_URL;

if (buildUrl) {
  // eslint-disable-next-line camelcase, @typescript-eslint/no-unused-vars
  __webpack_public_path__ = buildUrl;
}

export {};
